export default __webpack_public_path__ + "static/media/navigation.2a56977b.svg";